import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1890FF",
  d: "M18.278 2.726 17.273 1.72a.198.198 0 0 0-.27 0l-1.805 1.802a4.73 4.73 0 0 0-2.658-.812 4.73 4.73 0 0 0-3.355 1.388L6.769 6.512a.2.2 0 0 0-.056.134c0 .05.02.099.056.135l6.443 6.435a.19.19 0 0 0 .135.054.2.2 0 0 0 .135-.054l2.416-2.413a4.74 4.74 0 0 0 .577-6.004l1.804-1.803a.195.195 0 0 0 0-.27m-3.523 6.937-1.409 1.406-4.43-4.425 1.41-1.406a3.12 3.12 0 0 1 2.214-.917c.837 0 1.622.324 2.215.917.59.59.917 1.376.917 2.212s-.327 1.62-.918 2.212"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1890FF",
  d: "m1.722 17.274 1.005 1.004a.198.198 0 0 0 .27 0l1.806-1.803c.784.53 1.71.814 2.657.813a4.73 4.73 0 0 0 3.356-1.388l2.416-2.414a.2.2 0 0 0 .055-.134c0-.05-.02-.098-.055-.134L6.79 6.785a.19.19 0 0 0-.136-.055.2.2 0 0 0-.135.055L4.103 9.198a4.74 4.74 0 0 0-.577 6.004l-1.804 1.803a.193.193 0 0 0 0 .269m3.524-6.937 1.408-1.406 4.43 4.424-1.41 1.406c-.59.59-1.377.917-2.214.917a3.1 3.1 0 0 1-2.214-.917 3.1 3.1 0 0 1-.918-2.212c0-.835.327-1.62.918-2.212"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }